import store from '@/vuex/store';
import { cancelaAvisosEFechar } from '../../router/tokenExpirado';

export default {
  logout(app, next) {
    const sentences = [
      {
        id: 1,
        message: 'Deseja realmente sair do sistema?',
        bold: false,
      },
    ];

    app.$refs.modal.confirm(sentences, {
      yes: () => {
        cancelaAvisosEFechar(app);
        app.isAuthenticated = false;
        store.commit('setToken', '');
        store.commit('setAutenticados', []);
        store.commit('setFuncionario', {});
        next({ path: '/' });
        document.querySelector('.upper-off-canvas').classList.remove('fechado');
        document.querySelector('.off-canvas').classList.remove('fechado');
      },
      no: () => {
        next({ path: '/' });
      },
      title: 'Saindo do Sistema',
    });
  },
};



// WEBPACK FOOTER //
// ./src/pages/sair/index.js